import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://qifxhtlwwhmettlbzane.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpZnhodGx3d2htZXR0bGJ6YW5lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc4NjcwMzYsImV4cCI6MjA4MzQ0MzAzNn0.kca0YRcGLMBAS9PD5BGt5dPkVmIOHItPa8P507WBslE";

export const supabase = createClient(supabaseUrl, supabaseKey);
